import { render } from "./ScrollWidthShow.vue?vue&type=template&id=43600275&scoped=true"
import script from "./ScrollWidthShow.vue?vue&type=script&lang=js"
export * from "./ScrollWidthShow.vue?vue&type=script&lang=js"

import "./ScrollWidthShow.vue?vue&type=style&index=0&id=43600275&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43600275"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ScrollWidthShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43600275"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43600275', __exports__)) {
    api.reload('43600275', __exports__)
  }
  
  module.hot.accept("./ScrollWidthShow.vue?vue&type=template&id=43600275&scoped=true", () => {
    api.rerender('43600275', render)
  })

}


export default __exports__